import React from "react";

function NvrConnectionGuide() {
    return (
        <div style={{ display: "flex", flexDirection: "column", height: "calc(100vh - 56px)" }}>
            <iframe
                src="/nvr-connection-guide.html"
                title="NVR Connection Guide"
                style={{
                    flex: 1,
                    border: "none",
                    width: "100%",
                    borderRadius: 8,
                }}
            />
        </div>
    );
}

export default NvrConnectionGuide;
